module.exports = __webpack_public_path__ + "img/6.7363df5.webp";